import React from 'react';
import { Button } from '../../actions/Button';
import { ButtonColorsEnum } from '../../../constants/button-colors';
import { Tooltip } from '../../actions/Tooltip';
import { profilesHelpers } from 'modules/Settings/Profiles/Profiles.helpers';
import { SocialOAuthProvider, Network } from '../../../models/graphql';

export type ReconnectButtonViewProps = {
  //
  connected: boolean;
  breakpoint: 'small' | 'large';
  action: VoidFunction;
  oAuthProvider: SocialOAuthProvider;
  network: Network;
};

export const ReconnectButtonView = (props: ReconnectButtonViewProps): JSX.Element => {
  let buffer = <></>;
  const toolTipContent = (
    <>
      {props.oAuthProvider === SocialOAuthProvider.FACEBOOK
        ? 'Make sure you are currently logged into Facebook as an admin of the page'
        : `Make sure you are currently logged into the correct profile on ${profilesHelpers.getDisplayProfileName(
            props.oAuthProvider,
            props.network
          )}`}
    </>
  );
  if (props.breakpoint === 'small' && !props.connected) {
    buffer = (
      <div id={`reconnectButton${props.oAuthProvider}`} className={'cell shrink show-for-large'}>
        <Button
          type={'button'}
          variant={'hollow'}
          size={'small'}
          action={props.action}
          color={ButtonColorsEnum.secondary}>
          Reconnect
        </Button>
        <Tooltip pointer target={`#reconnectButton${props.oAuthProvider}`} type={'regular'}>
          {toolTipContent}
        </Tooltip>
      </div>
    );
  }
  if (props.breakpoint === 'large' && !props.connected) {
    buffer = (
      <div id={`reconnectButton${props.oAuthProvider}`} className={'grid-x cell hide-for-large margin-top-small-8'}>
        <Button
          expanded
          type={'button'}
          variant={'hollow'}
          size={'small'}
          action={props.action}
          color={ButtonColorsEnum.secondary}>
          Reconnect
        </Button>
        <Tooltip pointer target={`#reconnectButton${props.oAuthProvider}`} type={'regular'}>
          {toolTipContent}
        </Tooltip>
      </div>
    );
  }
  return buffer;
};
